import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["list", "more", "count"]

  connect() {
    reactor(this)
    this.observer = new ResizeObserver(() => this.count())
    this.observer.observe(this.element)
    this.count()
  }

  disconnect() {
    this.observer.disconnect()
  }

  morph() {
    this.count()
  }

  count() {
    this.moreTarget.hidden = true
    if (this.#wrapped() === 0) return

    // The +N chip takes width, so count again with it in place.
    this.moreTarget.hidden = false
    this.countTarget.textContent = `+${this.#wrapped()}`
  }

  #wrapped() {
    const chips = Array.from(this.listTarget.children)
    if (chips.length === 0) return 0

    const firstLine = chips[0].offsetTop
    return chips.filter((chip) => chip.offsetTop > firstLine).length
  }
}
